export const groupBy = <T>(
  array: T[],
  getKey: (value: T) => string | undefined
): Record<string, T[]> =>
  array.reduce((accumulator: Record<string, T[]>, item) => {
    const key = getKey(item);
    if (isPresent(key)) {
      const existingGroup = accumulator[key];
      if (existingGroup) {
        existingGroup.push(item);
      } else {
        accumulator[key] = [item];
      }
    }
    return accumulator;
  }, {}) ?? {};

export const getFirst = <T>(array: T[]): T | undefined =>
  array?.[0] ?? undefined;

export const isPresent = <T>(value: T | null | undefined): value is T => {
  return value !== null && value !== undefined;
};

export const shallowCopy = <T>(value: T): T => {
  if (Array.isArray(value)) {
    return [...value] as T;
  } else if (value && typeof value === "object") {
    return { ...value };
  }
  return value;
};

export const deepCopy = <T>(value: T): T => {
  if (value === null || typeof value !== "object") {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map((item) => deepCopy(item)) as unknown as T;
  }

  const result: Record<string | symbol, unknown> = {};

  for (const key of Reflect.ownKeys(value)) {
    result[key] = deepCopy((value as any)[key]);
  }

  return result as T;
};
